<!-- eslint-disable camelcase -->
<template>
  <section class="table-sampler-memory-chemical">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Instrumento</label>
        <select
          type="text"
          class="form-control"
          @change="setEquipmentData('instrument')"
          v-model="model.instrument_object"
        >
          <option
            v-for="instrument in instruments"
            :key="instrument.name"
            :value="instrument"
          >
            {{ instrument.name }}
          </option>
        </select>
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.instrument_serie"
          disabled
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.instrument_certificate"
          disabled
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.instrument_validity"
          disabled
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Calibrador</label>
        <select
          type="text"
          class="form-control"
          @change="setEquipmentData('gauge')"
          v-model="model.gauge_object"
        >
          <option
            v-for="calibrator in calibrators"
            :key="calibrator.name"
            :value="calibrator"
          >
            {{ calibrator.name }}
          </option>
        </select>
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.gauge_serie"
          disabled
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.gauge_certificate"
          disabled
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.gauge_validity"
          disabled
          required
        />
      </d-col>
    </d-form-row>

    <agent-list :listAgents.sync="model.agents" ref="list-agents" />

    <epi-list :list.sync="model.epis" />

    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Observações</label>
        <textarea
          type="text"
          class="form-control"
          placeholder="Observações"
          v-model="model.observation"
          required
        />
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import { cloneDeep } from '_utils';
import EquipmentMixin from '_common/mixins/EquipmentMixin';
import { CHEMICAL_MEMORY, _LOAD_MODEL_ } from '../../SampleModel';
import EpiList from '../EPIList.vue';
import AgentList from '../AgentList.vue';

const TypeMap = {
  instruments: 'instrumento',
  calibrators: 'calibrador',
};

export default {
  name: 'Sample-Memory-Chemical',
  mixins: [EquipmentMixin],
  props: {
    memory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(CHEMICAL_MEMORY),
    };
  },
  components: {
    EpiList,
    AgentList,
  },
  methods: {
    ...mapActions(['setSample']),
    setModel() {
      if (this.memory) {
        this.model = this.memory;
      }
    },
    handleLoadModel() {
      this.setModel();
    },
  },
  mounted() {
    this.setModel();
    this.getListEquipments('instruments', TypeMap);
    this.getListEquipments('calibrators', TypeMap);
    Events.$on(_LOAD_MODEL_, this.handleLoadModel);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this.handleLoadModel);
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:memory', value);
        this.setSample({ ...this.$store.state.sample.sample, ...{ memory_field: value } });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-memory-chemical {
  label {
    margin-bottom: 0;
  }
}
</style>
